import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseFilledYellow = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 9,
		cy: 9,
		r: 9,
		fill: "#EB9D06"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.79547 9L12.022 6.77344C12.1277 6.66795 12.1871 6.52481 12.1873 6.3755C12.1874 6.22619 12.1282 6.08294 12.0227 5.97726C11.9172 5.87159 11.7741 5.81215 11.6248 5.81202C11.4755 5.81189 11.3322 5.87108 11.2266 5.97656L9 8.20312L6.77344 5.97656C6.66776 5.87089 6.52444 5.81152 6.375 5.81152C6.22556 5.81152 6.08223 5.87089 5.97656 5.97656C5.87089 6.08223 5.81152 6.22556 5.81152 6.375C5.81152 6.52444 5.87089 6.66776 5.97656 6.77344L8.20312 9L5.97656 11.2266C5.87089 11.3322 5.81152 11.4756 5.81152 11.625C5.81152 11.7744 5.87089 11.9178 5.97656 12.0234C6.08223 12.1291 6.22556 12.1885 6.375 12.1885C6.52444 12.1885 6.66776 12.1291 6.77344 12.0234L9 9.79687L11.2266 12.0234C11.3322 12.1291 11.4756 12.1885 11.625 12.1885C11.7744 12.1885 11.9178 12.1291 12.0234 12.0234C12.1291 11.9178 12.1885 11.7744 12.1885 11.625C12.1885 11.4756 12.1291 11.3322 12.0234 11.2266L9.79547 9Z",
		fill: "white"
	})]
});
export default SvgCloseFilledYellow;
